
const message_url = 'https://catalogo.artlineagioielli.it/ocr_ws';  // URL del tuo backend
 
 
export const sendMessageToServer = async (message) => {
  try {
	  
    const browserInfo = navigator.userAgent;  // Informazioni sul browser e sistema operativo
    const language = navigator.language || navigator.userLanguage;  // Lingua preferita del client
    const deviceInfo = `${window.innerWidth}x${window.innerHeight}`;  // Risoluzione dello schermo
	  
	  
	  
    const response = await fetch(`${message_url}/logClientJS?message=${encodeURIComponent(message)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Client-Browser': browserInfo,  // Header personalizzato per il browser
        'X-Client-Language': language,  // Header personalizzato per la lingua
        'X-Client-Device': deviceInfo,  // Header personalizzato per il dispositivo (risoluzione dello schermo)
      },
    });
    if (!response.ok) {
      throw new Error('Errore durante l\'invio del messaggio');
    }
    const data = await response.json();  // Converte la risposta in JSON
    return data;  // Ritorna i dati della risposta dal server
  } catch (error) {
    console.error('Errore durante l\'invio del messaggio:', error);
    throw error;  // Lancia l'errore in modo che possa essere gestito dal chiamante
  }
};